document.addEventListener("click", (e) => {
  document.querySelectorAll("details.regions-menu[open]").forEach((details) => {
    if (!details.contains(e.target)) {
      details.removeAttribute("open");
    }
  });
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    document.querySelectorAll("details.regions-menu[open]").forEach((details) => {
      details.removeAttribute("open");
    });
  }
});